const STEPS = [
  ["1", "Current position", "What risk capital is exposed today"],
  ["2", "Strategic potential", "What modeled improvement is possible"],
  ["3", "Capital efficiency", "Where policy evidence and accepted Portfolio economics remain disciplined"],
  ["4", "Execution readiness", "What constraints are still needed"],
  ["5", "Portfolio Capital Strategy", "Where Management applies judgement"],
];

export default function ExecutiveJourneyIndicator() {
  return <nav aria-label="Executive journey" className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
    <ol className="grid gap-3 md:grid-cols-5">
      {STEPS.map(([number, label, description]) => <li key={number} className="rounded-xl bg-slate-50 p-4">
        <div className="flex items-center gap-3">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-cyan-700 text-xs font-semibold text-white">{number}</span>
          <p className="text-sm font-semibold text-slate-900">{label}</p>
        </div>
        <p className="mt-2 text-xs leading-5 text-slate-500">{description}</p>
      </li>)}
    </ol>
  </nav>;
}
